module.exports = __webpack_public_path__ + "static/media/Monday_Step3_Image0.274f6853.jpg";